/** Router location.state key: user just approved their first payout from the cash-out screen. */
export const FROM_FIRST_APPROVAL_STATE_KEY = 'fromFirstApproval';

/** Router location.state key: confirm flow was opened from the Expenses tab. */
export const FROM_EXPENSES_STATE_KEY = 'fromExpenses';

/** Router location.state key: open the end-user side menu after navigation. */
export const OPEN_SIDE_MENU_STATE_KEY = 'openSideMenu';

/** Minimum full-page skeleton display before routing to HSA Paydays after first approval. */
export const FIRST_APPROVAL_SKELETON_MIN_MS = 1000;

/** Duration the HSA success screen is shown before redirecting to HSA Paydays. */
export const HSA_SUCCESS_DISPLAY_MS = 3000;

export type FirstApprovalNavigationState = {
  [FROM_FIRST_APPROVAL_STATE_KEY]?: boolean;
};

export type FromExpensesNavigationState = {
  [FROM_EXPENSES_STATE_KEY]?: boolean;
};

export type OpenSideMenuNavigationState = {
  [OPEN_SIDE_MENU_STATE_KEY]?: boolean;
};

export const openSideMenuNavigationState: OpenSideMenuNavigationState = {
  [OPEN_SIDE_MENU_STATE_KEY]: true,
};

export const fromExpensesConfirmNavigationState: FromExpensesNavigationState = {
  [FROM_EXPENSES_STATE_KEY]: true,
};

export function readFromFirstApprovalNavigationState(state: unknown): boolean {
  if (state == null || typeof state !== 'object') {
    return false;
  }

  return (state as FirstApprovalNavigationState)[FROM_FIRST_APPROVAL_STATE_KEY] === true;
}

export function readFromExpensesNavigationState(state: unknown): boolean {
  if (state == null || typeof state !== 'object') {
    return false;
  }

  return (state as FromExpensesNavigationState)[FROM_EXPENSES_STATE_KEY] === true;
}

export function readOpenSideMenuNavigationState(state: unknown): boolean {
  if (state == null || typeof state !== 'object') {
    return false;
  }

  return (state as OpenSideMenuNavigationState)[OPEN_SIDE_MENU_STATE_KEY] === true;
}
